import { Menu } from "@headlessui/react";
import { Icon } from "~/ui-library";
import { ArrowUturnRightIcon } from "~/ui-library/icons";

export const SocialMediaShareMenuButton: React.FC<{ className?: string }> = ({
  className,
  ...rest
}) => (
  <Menu.Button className={className} {...rest}>
    <div className="flex items-center justify-center gap-xxs font-semibold">
      <Icon className="fill-transparent" SvgIcon={ArrowUturnRightIcon} />
      Share
    </div>
  </Menu.Button>
);
